<template>
  <div class="section-label">
    <div class="font-semibold flex items-center">
      <div class="text-secondary">{{ label }}</div>
      <Icon
        v-if="helpText"
        v-tippy="helpText"
        type="question-circle"
        class="ml-1 text-quaternary text-sm"
        fa-style="far"
      />
    </div>
    <div
      v-if="description"
      class="text-tertiary"
    >
      {{ description }}
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '@/components/icon/Icon.vue'

defineProps({
  label: {
    type: String,
    required: true,
    default: null
  },
  description: {
    type: String,
    required: false,
    default: null
  },
  helpText: {
    type: String,
    required: false,
    default: null
  }
})
</script>

<style></style>
